import React from 'react'
import { NoSearchIcon } from '../../../assets/images'
import './NoSearch.scss'

const NosearchResult = () => {
  return (
    <div className='col-md-12 d-flex justify-content-center align-items-center flex-column mt-5 pt-3'>
    
            <div>
            <img src={NoSearchIcon} alt="" />
            </div>

            <div className='text-div'>
            Sorry! We could not find any matches for your entry.
            </div>

            <div className='try-again'>
               Please try searching for another text
            </div>
       
    </div>
   
  )
}

export default NosearchResult